import _ from "lodash";
import {
  Component,
} from "react";
import {
  Button,
  Dropdown,
  DropdownButton,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  InputGroup,
  Modal,
} from "react-bootstrap";
import cls from "classnames";
import moment from "moment";
import FloatingPopup from "CommonComponents/floating-popup";
import numeral from "numeral";

import store from "CommonState/store";
import {
  Awesome,
  Checkbox,
  CustomDatePicker,
  DelayedTooltip,
  Radio,
  Spinner,
} from "CommonComponents/bricks";
import {
  defaultFilterCriterion,
  defaultSort,
  injectGenerator,
} from "CommonCore/schema-util";
import {
  formatNumber,
  IsoDateFormat,
  LocaleDateFormat,
} from "CommonCore/l10n";
import {
  renderChildren,
} from "CommonCore/router-util";
import TipLink from "Components/tip-link";

function focusIfOpen(input) {
  if (input) {
    /*
     * without a timeout, thepage scroll position jumps, probably
     * because of the tether.
     */
    setTimeout(() => input.focus(), 50);
  }
}

function maybeDebounce(f, timeout) {
  return timeout ? _.debounce(f, timeout) : f;
}

@store
class TextCriterion extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    this.applyNewTextDelayed = maybeDebounce(this.applyNewText, this.props.debounce);
  }

  render() {
    const { filter, schema } = this.props;
    let { text, leer } = this.state;

    if (_.isUndefined(leer)) {
      leer = _.isNull(filter.criteria) || _.isNull(text);
    }
    if (!_.isString(text)) {
      text = filter.criteria || "";
    }

    return <form onSubmit={this.close}><FormControl
      ref={focusIfOpen}
      value={text}
      disabled={leer}
      onChange={this.textChanged}
      placeholder={schema.display} />
    <div><Checkbox label='Leer' checked={leer} onChange={this.onLeerClicked} /></div>
    </form>;
  }

  textChanged = evt => {
    const text = evt.target.value;
    this.setState({ text });
    this.applyNewTextDelayed(text);
  };

  close = evt => {
    evt.preventDefault();
    this.applyNewText(this.state.text);
    this.props.onClose();
    return false;
  };

  applyNewText = text => {
    const { list, filter, setUiListFilterCriteria } = this.props;
    setUiListFilterCriteria(list, filter.field, text);
  };

  onLeerClicked = ({ target }) => {
    let { text } = this.state;
    const leer = target.checked;
    text = leer ? null : (text || "");
    this.setState({ leer, text });
    this.applyNewText(text);
  };
}

@store
class NumberCriterion extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    this.applyStateToFilterDelayed = maybeDebounce(this.applyStateToFilter, this.props.debounce);
  }

  render() {
    const { filter: { criteria } = {} } = this.props;
    const {
      op = criteria.op,
      equalTo = criteria.equalTo || "",
      atLeast = criteria.atLeast || "",
      atMost = criteria.atMost || "",
    } = this.state;

    return <div className='filter-criterion-container'>
      <div><Radio label='Gleich' checked={op === "="} data-op='=' onChange={this.applyOp} />
        <FormControl
          placeholder='Wert' ref={focusIfOpen} data-type='equalTo' onBlur={this.commitValue}
          value={equalTo} onChange={this.applyValue} />
      </div>
      <div><Radio label='Zwischen' checked={op === "><"} data-op='><' onChange={this.applyOp} />
        <FormControl
          placeholder='Mindestwert' data-type='atLeast' onBlur={this.commitValue}
          value={atLeast} onChange={this.applyValue} />
        <span>und</span>
        <FormControl
          placeholder='Höchstwert' data-type='atMost' onBlur={this.commitValue}
          value={atMost} onChange={this.applyValue} />
      </div>
      <div><Radio label='Leer' checked={op === "!"} data-op='!' onChange={this.applyOp} /></div>
    </div>;
  }

  applyOp = ({ target }) => {
    this.applyChanges({ op: target.getAttribute("data-op") });
  };

  applyValue = ({ target }) => {
    this.applyChanges({ [target.getAttribute("data-type")]: target.value });
  };

  applyChanges(changes) {
    if (changes.equalTo) {
      changes.op = "=";
    } else if (changes.atLeast || changes.atMost) {
      changes.op = "><";
    }

    if (changes.op != "=") {
      changes.equalTo = "";
    }
    if (changes.op != "><") {
      changes.atLeast = "";
      changes.atMost = "";
    }

    this.setState(changes);
    this.applyStateToFilterDelayed(changes);
  }

  commitValue = ({ target }) => {
    if (!_.isEmpty(target.value)) {
      // + 29.03.2017 TH: numeralFormat verwenden
      const n = formatNumber(numeral(target.value).value(), this.props.schema.numeralFormat);
      if (n !== target.value) {
        this.setState({ [target.getAttribute("data-type")]: n });
      }
    }
  };

  applyStateToFilter = changes => {
    const { list, filter, setUiListFilterCriteria } = this.props;
    const criteria = _.mapValues(
      _.pickBy(_.assign({}, this.props.filter.criteria, changes)),
      (v, key) => key !== "op" ? numeral(v).value() : v,
    );
    setUiListFilterCriteria(list, filter.field, criteria);
  };
}

@store
class BooleanCriterion extends Component {
  render() {
    const { filter } = this.props;
    return <div>
      <Radio vertical key='true' label='Ja' checked={filter.criteria} onChange={this.setToTrue} />
      <Radio vertical key='false' label='Nein' checked={!filter.criteria} onChange={this.setToFalse} />
    </div>;
  }

  setToTrue = () => {
    const { list, filter, setUiListFilterCriteria } = this.props;
    setUiListFilterCriteria(list, filter.field, true);
  };

  setToFalse = () => {
    const { list, filter, setUiListFilterCriteria } = this.props;
    setUiListFilterCriteria(list, filter.field, false);
  };
}

@store
class MultiselectCriterion extends Component {
  render() {
    const {
      filter,
      schema,
    } = this.props;

    const { choices, displayChoices } = this.choices;
    const { hierarchy, noEmpty, emptyName = "Leer" } = schema.filterbox;
    return <div>
      {!noEmpty && <Checkbox vertical label={emptyName} checked={-1 !== _.findIndex(filter.criteria, _.isNull)} onChange={this.selectOnlyEmpty} />}
      {!noEmpty && <hr />}
      {displayChoices.map((choice, i) => <Checkbox
        vertical
        label={choice}
        style={{ marginLeft: hierarchy && `${ hierarchy.depth(choices[i]) * 1.5 }em` }}
        key={i}
        checked={!!_.find(filter.criteria, f => f === choice)}
        onChange={() => this.select(choice)} />)}
    </div>;
  }

  get filterbox() {
    return this.props.schema.filterbox;
  }

  get choices() {
    const { injects } = this.props;
    const { choices, hierarchy, inject } = this.filterbox;
    let choiceList;
    if (_.isFunction(choices)) {
      choiceList = injectGenerator(choices, inject, injects);
    } else {
      choiceList = choices;
    }
    const displayChoices = hierarchy ? choiceList.map(hierarchy.display) : choiceList;
    return { choices: choiceList, displayChoices };
  }

  select = choice => {
    const { list, filter, setUiListFilterCriteria } = this.props;
    const criteria = _.filter(_.cloneDeep(filter.criteria), _.identity);
    const { hierarchy } = this.filterbox;
    const { choices, displayChoices } = this.choices;
    let rootIndex;
    let rootDepth;

    if (hierarchy) {
      rootIndex = displayChoices.indexOf(choice);
      rootDepth = hierarchy.depth(choices[rootIndex]);
    }

    const ci = _.findIndex(criteria, f => f === choice);
    if (ci === -1) {
      criteria.push(choice);
      if (hierarchy) {
        for (let i = rootIndex + 1; i < choices.length && hierarchy.depth(choices[i]) > rootDepth; ++i) {
          if (_.findIndex(criteria, f => f === displayChoices[i]) === -1) {
            criteria.push(displayChoices[i]);
          }
        }
      }
    } else {
      criteria.splice(ci, 1);
      if (hierarchy) {
        for (let i = rootIndex + 1; i < choices.length && hierarchy.depth(choices[i]) > rootDepth; ++i) {
          const si = _.findIndex(criteria, f => f === displayChoices[i]);
          if (si !== -1) {
            criteria.splice(si, 1);
          }
        }
      }
    }
    setUiListFilterCriteria(list, filter.field, criteria);
  };

  selectOnlyEmpty = () => {
    const { list, filter, setUiListFilterCriteria } = this.props;
    setUiListFilterCriteria(
      list,
      filter.field,
      _.findIndex(filter.criteria, _.isNull) !== -1 ? [] : [null],
    );
  };
}

@store
class DateCriterion extends Component {
  render() {
    const { filter } = this.props;
    return <div>
      <Radio label='gleich' data-comp='=' inline checked={filter.criteria.comparison === "="} onChange={this.setComparison} />
      <Radio label={filter.criteria.today ? "bis" : "vor"} data-comp='<' inline checked={filter.criteria.comparison === "<"} onChange={this.setComparison} />
      <Radio label='nach' data-comp='>' inline checked={filter.criteria.comparison === ">"} onChange={this.setComparison} />
      <div className='filter-date-picker'>
        <CustomDatePicker
          value={filter.criteria.date}
          onChange={this.setDate}
          disabled={filter.criteria.today}
          isClearable
          name='dateinput-filter'
        />
      </div>
      <div><Checkbox label='Heute' checked={filter.criteria.today || false} onChange={this.setToday} /></div>
      <div><Radio label='Leer' inline checked={filter.criteria.empty || false} onChange={this.setEmpty} /></div>
    </div>;
  }

  setCriteria(body) {
    const { list, setUiListFilterCriteria, filter } = this.props;
    const criteria = _.cloneDeep(filter.criteria);
    body(criteria);
    setUiListFilterCriteria(list, filter.field, criteria);
  }

  setComparison = evt => {
    this.setCriteria(criteria => {
      criteria.comparison = evt.target.getAttribute("data-comp");
      criteria.empty = false;
    });
  };

  setDate = dateString => {
    if (dateString) {
      this.setCriteria(criteria => {
        criteria.date = dateString;
        criteria.empty = false;
      });
    }
  };

  setEmpty = () => {
    this.setCriteria(criteria => {
      delete criteria.date;
      delete criteria.today;
      delete criteria.comparison;
      criteria.empty = true;
    });
  };

  setToday = ({ target }) => {
    this.setCriteria(criteria => {
      criteria.empty = false;
      criteria.today = target.checked;
      if (criteria.today) {
        delete criteria.date;
      } else {
        criteria.date = moment.utc().format(IsoDateFormat);
      }
    });
  };
}

@store
export class FilterCriterion extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    if (this.props.autoOpen) {
      this.setState({ open: true });
    }
  }

  render() {
    const {
      list,
      schema,
      filter,
      injects,
      noRemove,
      debounce,
    } = this.props;
    const { open } = this.state;
    const field = schema.filters[filter.field];
    const formattedCriteria = this.formatCriteria();
    const noOverflow = !!_.isObject(field.filterbox);
    const emptyName = (field.filterbox && field.filterbox.emptyName) || "Leer";

    return <FloatingPopup
      open={open}
      onClose={this.closeMenu}
      placement='bottom-start'
      renderTarget={ref => (
        <span
          ref={ref}
          role='button'
          className={cls({ "filter-criterion": true, open })}
          onClick={this.toggleMenu}
          title={formattedCriteria}>
          <span>{field.display}:</span>
          <span className={`criterion-text${ field.filterbox.requiredHint ? "-wide" : "" }`}>
            {formattedCriteria}
            {!formattedCriteria &&
              <i className='text-muted'>
                {field.filterbox.requiredHint}
                {!field.filterbox.requiredHint && (_.isNull(formattedCriteria) || (filter.criteria && filter.criteria.op) == "!" ? emptyName : "Alle")}
              </i>
            }
          </span>
          <Awesome name='caret-down' />
          {!noRemove && <Button size='sm' variant='link' onClick={this.removeSelf}>
            <Awesome name='times-circle' />
          </Button>}
        </span>
      )}
      renderPopup={(ref, style) => (
        <div ref={ref} style={style} className={cls({ "filter-criterion-popup": true, "no-overflow": noOverflow })}>
          {field.filterbox === "text" &&
              <TextCriterion
                list={list}
                filter={filter}
                schema={field}
                onClose={this.closeMenu}
                debounce={debounce} />
          }
          {field.filterbox === "number" &&
              <NumberCriterion
                list={list}
                filter={filter}
                schema={field}
                onClose={this.closeMenu}
                debounce={debounce} />
          }
          {field.filterbox === "boolean" &&
              <BooleanCriterion list={list} filter={filter} schema={field} />}
          {field.filterbox === "date" &&
              <DateCriterion list={list} filter={filter} />}

          {field.filterbox.choices && field.filterbox.hierarchySearch &&
              <MultiselectCriterion
                list={list}
                filter={filter}
                schema={field}
                injects={injects}
                hierarchySearch={true}
              />}
          {field.filterbox.choices && !field.filterbox.hierarchySearch && !field.filterbox.searchable && !field.filterbox.singleSelect &&
              <MultiselectCriterion
                list={list}
                filter={filter}
                schema={field}
                injects={injects}
              />}
        </div>
      )} />;
  }

  formatCriteria() {
    const { filter, schema } = this.props;
    const { filterbox } = schema.filters[filter.field];
    if (filterbox === "boolean") {
      return filter.criteria ? "Ja" : "Nein";
    } else if (filterbox === "date") {
      if (filter.criteria.empty) {
        return "Leer";
      }

      const { date, comparison, today } = filter.criteria;

      if (today) {
        switch (comparison) {
          case ">": return "Nach heute";
          case "<": return "Bis heute";
          case "=": return "Heute";
        }
      }

      const comparisonStr = comparison === ">"
? "Nach "
        : comparison === "<"
? "Vor "
          : "";
      return `${ comparisonStr }${ moment.utc(date).format(LocaleDateFormat) }`;
    } else if (_.isArray(filter.criteria)) {
      return _.isNull(filter.criteria[0]) ? null : _.sortBy(filter.criteria).join("; ");
    } else if (filterbox === "number") {
      const { op, equalTo, atLeast, atMost } = filter.criteria;
      const fmt = schema.filters[filter.field].numeralFormat; // + 29.03.2017 TH: numeralFormat verwenden
      if (op === "=") {
        return _.isNumber(equalTo) ? formatNumber(equalTo, fmt) : "";
      }
      if (!_.isUndefined(atLeast) && !_.isUndefined(atMost)) {
        return `zwischen ${ formatNumber(atLeast, fmt) } und ${ formatNumber(atMost, fmt) }`;
      } else if (!_.isUndefined(atLeast)) {
        return `≥ ${ formatNumber(atLeast, fmt) }`;
      } else if (!_.isUndefined(atMost)) {
        return `≤ ${ formatNumber(atMost, fmt) }`;
      }
    } else {
      return filter.criteria;
    }
  }

  removeSelf = () => {
    const { list, filter, removeUiListFilter } = this.props;
    removeUiListFilter(list, filter.field);
  };

  toggleMenu = () => {
    this.setState({ open: !this.state.open });
  };

  closeMenu = () => {
    this.setState({ open: false });
  };
}

@store
export default class FilterBar extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    this.setState({ autoOpen: false });
    this.setStringFilterDelayed = maybeDebounce(this.setStringFilter, this.props.debounce);
  }

  render() {
    const {
      list,
      filter = [],
      schema,
      injects,
      userFilters,
      currentUserFilter,
      debounce,
      minGeneralSearchLength = 2,
      sort,
    } = this.props;

    let {
      searchText,
    } = this.state;
    const {
      askForDelete,
      askForFilterName,
      filterNameInput,
      saveInProgress,
      autoOpen,
      showSearchLengthTooltip,
    } = this.state;

    if (!_.isString(searchText)) {
      searchText = _.find(filter, _.isString) || "";
    }

    const fieldFilters = filter.filter(f => !_.isString(f));

    let availableFilters = Object.keys(schema.filters)
      .filter(field => !_.some(filter, f => f.field === field)
        && schema.filters[field].filterbox);
    availableFilters = _.sortBy(availableFilters, f => schema.filters[f].display.toLowerCase());

    const isFilterEmpty = !currentUserFilter
      && (_.isEmpty(filter) || _.isEqual(filter, [""]))
      && (_.isEmpty(sort) || this.isDefaultSort(sort));
    const isFilterModified = currentUserFilter
      && !_.isEqual(userFilters[currentUserFilter], this.combineSortWithFilter(this.sortClone(filter)));

    return <div>
      <span className='filter-criterion-layout'>
        <DropdownButton
          variant='outline-primary'
          title={isFilterModified ? `${ currentUserFilter } *` : currentUserFilter || "Neue Suche"}
          id={`${ list }-userFilters`}
          onSelect={this.loadUserFilter}>
          <Dropdown.Item eventKey=''>Neue Suche</Dropdown.Item>
          {!_.isEmpty(userFilters) && <Dropdown.Divider />}
          {_.keys(userFilters).map(filterName => <Dropdown.Item eventKey={filterName} key={filterName}>{filterName}</Dropdown.Item>)}
        </DropdownButton>
      </span>
      <span className='filter-criterion-layout'>
        {currentUserFilter
          ? <DropdownButton
            variant='primary'
            onSelect={this.doUserFilterAction}
            title={saveInProgress ? <Spinner /> : "Suche verwalten"}
            disabled={saveInProgress}
            id={`${ list }-filterActions`}
          >
            <Dropdown.Item eventKey='saveUserFilter'>Speichern</Dropdown.Item>
            <Dropdown.Item eventKey='saveUserFilterAs'>Speichern unter</Dropdown.Item>
            <Dropdown.Item disabled={!isFilterModified} eventKey='restoreUserFilter'>Änderungen verwerfen</Dropdown.Item>
            <Dropdown.Item disabled={!currentUserFilter} eventKey='beginDeleteUserFilter'>Löschen</Dropdown.Item>
          </DropdownButton>
          : <Button
            variant='outline-primary'
            onClick={this.saveUserFilter}
            disabled={isFilterEmpty || saveInProgress}
          >
            Suche speichern
          </Button>
        }

      </span>

      <Form as='span' className='filter-criterion-layout'>
        <FormGroup>
          <DelayedTooltip
            delay={500}
            condition={showSearchLengthTooltip}
            overlay={`Es sind mindestens ${ minGeneralSearchLength } Zeichen erforderlich.`
            }>
            <InputGroup>
              <InputGroup.Text>
                <Awesome name='search' />
              </InputGroup.Text>
              <FormControl
                placeholder='Tabelle durchsuchen'
                value={searchText}
                onChange={this.onStringFilterChanged} />
              <span style={{ display: "flex", marginLeft: "-1px" }}><InputGroup.Text><TipLink
                overlay='Suchmuster entfernen' to='' onClick={e => {
                  e.preventDefault();
                  this.setState({ searchText: "" });
                  this.setStringFilterDelayed("");
                }}><Awesome name='trash' /></TipLink></InputGroup.Text></span>
            </InputGroup>
          </DelayedTooltip>
        </FormGroup>
      </Form>

      {fieldFilters.map(f => <FilterCriterion
        key={f.field}
        list={list}
        schema={schema}
        injects={injects}
        autoOpen={autoOpen}
        debounce={debounce}
        filter={f} />)}

      <DropdownButton
        variant='primary' onSelect={this.toggleFilter}
        title='Weitere Filteroptionen' id={`${ list }-filters`}
        disabled={!availableFilters.length}>
        {availableFilters.map(field => <Dropdown.Item key={field} eventKey={field}>{schema.filters[field].display}</Dropdown.Item>)}
      </DropdownButton>

      {renderChildren(this.props)}

      <Modal show={askForFilterName} onHide={this.closeSaveUserFilter}>
        <Modal.Header><h3>Suche benennen</h3></Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.saveUserFilter}>
            <FormGroup>
              <FormLabel>Name der Suche</FormLabel>
              <FormControl autoFocus value={filterNameInput || ""} onChange={this.setUserFilterInput} />
            </FormGroup>
            <button style={{ display: "none" }} type='submit' />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={!filterNameInput || saveInProgress}
            variant='primary' onClick={this.saveUserFilter}>
            Speichern
          </Button>
          <Button variant='link' onClick={this.closeSaveUserFilter}>Abbrechen</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={askForDelete} onHide={this.closeDelete}>
        <Modal.Header><h3>Suche löschen</h3></Modal.Header>
        <Modal.Body>
          <span>Sind Sie sicher, dass Sie die Suche <strong>{currentUserFilter}</strong> löschen
            möchten? Diese Aktion kann <strong>nicht</strong> rückgängig gemacht werden.</span>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={saveInProgress}
            variant='primary' onClick={this.deleteUserFilter}>
            Löschen
          </Button>
          <Button variant='link' onClick={this.closeDelete}>Abbrechen</Button>
        </Modal.Footer>
      </Modal>
    </div>;
  }

  onStringFilterChanged = evt => {
    const filter = evt.target.value;
    this.setState({ searchText: filter });
    this.setStringFilterDelayed(filter);
  };

  setStringFilter = filter => {
    const { setUiListStringFilter, list, minGeneralSearchLength = 2 } = this.props;
    if (filter && filter.length < minGeneralSearchLength) {
      if (!this.state.showSearchLengthTooltip) {
        this.setState({ showSearchLengthTooltip: true });
      }
      return;
    } else if (this.state.showSearchLengthTooltip) {
      this.setState({ showSearchLengthTooltip: false });
    }
    setUiListStringFilter(list, filter);
  };

  toggleFilter = fieldName => {
    this.setState({ autoOpen: true });
    const { toggleUiListFilter, list, schema } = this.props;
    const opts = schema.filters[fieldName];
    const initial = defaultFilterCriterion(opts);
    toggleUiListFilter(list, fieldName, initial);
  };

  loadUserFilter = filterName => {
    const { loadUiListFilter, list, schema } = this.props;
    loadUiListFilter(list, filterName, defaultSort(schema));
    this.setState({ searchText: undefined });
  };

  saveUserFilter = async function(evt) {
    if (evt) {
      evt.preventDefault();
    }

    const {
      list,
      currentUserFilter,
      saveUiListFilter,
      filter,
    } = this.props;
    const { filterNameInput } = this.state;
    const name = filterNameInput || currentUserFilter;
    if (!name) {
      this.setState({
        askForFilterName: true,
        filterNameInput: "",
      });
    } else {
      this.setState({ saveInProgress: true });
      await saveUiListFilter(list, name, this.sortClone(filter));
      this.closeSaveUserFilter();
    }

    return false;
  }.bind(this);

  doUserFilterAction = async function(action) {
    try {
      this.setState({ saveInProgress: true });
      await this[action]();
    } finally {
      this.setState({ saveInProgress: false });
    }
  }.bind(this);

  saveUserFilterAs = () => {
    this.setState({
      askForFilterName: true,
      filterNameInput: this.props.currentUserFilter,
    });
  };

  deleteUserFilter = () => {
    this.closeDelete();
    const { deleteUiListFilter, list, currentUserFilter } = this.props;
    return deleteUiListFilter(list, currentUserFilter);
  };

  restoreUserFilter = () => {
    this.loadUserFilter(this.props.currentUserFilter);
  };

  closeSaveUserFilter = () => {
    this.setState({
      askForFilterName: false,
      saveInProgress: false,
      filterNameInput: null,
    });
  };

  setUserFilterInput = evt => {
    this.setState({
      filterNameInput: evt.target.value,
    });
  };

  beginDeleteUserFilter = () => {
    this.setState({
      askForDelete: true,
    });
  };

  closeDelete = () => {
    this.setState({
      askForDelete: false,
    });
  };

  isDefaultSort(sort) {
    const { schema } = this.props;
    return _.isEqual(defaultSort(schema), sort);
  }

  sortClone = filter => {
    const { schema } = this.props;
    return _.sortBy(filter, f => !_.isString(f), f => !_.isString(f) && schema.filters[f.field].display);
  };

  combineSortWithFilter = filter => {
    const { sort } = this.props;
    const filterClone = _.cloneDeep(filter);
    sort.forEach((s, index) => {
      const zugehFilter = filterClone.find(f => f.field === s.key);
      if (zugehFilter) {
        zugehFilter.sort = { pos: index, reverse: s.reverse || false };
      } else {
        filterClone.push({ field: s.key, sort: { pos: index, reverse: s.reverse || false } });
      }
    });
    return filterClone;
  };
}
